import { createSlice } from "@reduxjs/toolkit";
import { getPurchaseOrder } from "../../reduxApi/admin/PurchaseOrderReduxApi";
import { getSupplierApi } from "../../reduxApi/admin/SupplierReducApi";

const SupplierSlice = createSlice({
  name: "Supplier",
  initialState: {
    status: "idle",
    getSupplier: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSupplierApi.fulfilled, (state, action) => {
      state.status = "fulfilled";
      state.getSupplier = action.payload.supplier;
      console.log("state.getsupplier", state.getSupplier);
    });
  },
});

export default SupplierSlice.reducer;
